import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class HelpCssClassService extends FormulateCssClassService {
    public process(): void {
        this.addClass([
                'mb-4',
                'text-gray-dark',
            ],
        )
        if (this.isBox()) {
            this.addClass('-mt-2')
        }

        if(this.isUpload()) {
            this.addClass('mt-2');
        }
    }
}

export default HelpCssClassService
